<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex x16>
        <v-card>
          <v-card-title>
            <v-text-field v-model="search" type="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              :headers="headers"
              :items="devices"
              :items-per-page="5"
              class="elevation-5"
          >
          <template slot="headerCell" slot-scope="props">
            <span>{{ props.header.text }}</span>
          </template>
          
          <template slot="items" slot-scope="props">
            <td >{{ props.item.name }}</td>
            <td >{{ props.item.reference }}</td>
            <td >{{props.item.init_survey}}</td>
            <td>
              <span v-for="(item, i) in props.item.managers" :key="i">
                <span v-if="i > 0 "> | </span>
                {{ item }}
              </span>
            </td>
            <td>
              <v-chip outline :color="props.item.status ? 'green' : 'red'">
                {{ props.item.status ? 'ONLINE' : 'OFFLINE' }}
              </v-chip>
            </td>
            <td>{{ props.item.group }}</td>
            <td>{{ props.item.token.toUpperCase() }}</td>
            <td class="justify-center layout px-0">
              <div class="text-center d-flex">
                  <v-btn class="mr-0" icon @click="getQrCode(props.item.token)">
                    <v-icon color="primary">qr_code_2</v-icon>
                  </v-btn>
                  <v-btn class="mr-0" icon @click="openSurvey(props.item.token);">
                    <v-icon color="primary">remove_red_eye</v-icon>
                  </v-btn>
              </div>            
            </td>
          </template>
        </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  data () {
    return {
      search: '',
      pagination: {
        rowsPerPage: 25
      },
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Reference', value: 'reference' },
        { text: 'Init', value: 'init_survey' },
        { text: 'Managers', value: 'managers' },
        { text: 'Status', value: 'status' },
        { text: 'Group', value: 'group' },
        { text: 'Token', value: 'token' },
        { text: 'Actions', value: 'actiions', sortable: false }
      ],
      devices: [],
    };
  },
  computed: {
    ...mapGetters(['loading', 'clients', 'client'])
  },
  watch: {
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.$store.commit('setLoading', true);
      let url = '/client/devices';
      window.axios.get(url).then((response) => {
        this.devices = response.data.data;
        this.$store.commit('setLoading', false);
      });
    },
    openSurvey (token) {
      let routeData = this.$router.resolve({
        name: 'SurveyDevices', 
        params: { token: token },
      });
      window.open(routeData.href, '_blank');
    },
    getQrCode (token) {
      let url = '/devices/' + token + '/generate-qrcode';
      
      window.axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'qrcode-' + token + '.png');
        document.body.appendChild(link);
        link.click();
      });
    }
  },
  
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/devices/List.vue